<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="documents"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{ 'items-per-page-text': 'Số Hồ Sơ một trang' }"
      v-bind="this.$attrs"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const originHeaders = [
  {
    text: 'Họ tên',
    value: 'name',
    align: 'left',
    sortable: false
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false
  },
  {
    text: 'Phòng thi',
    value: 'rooms',
    align: 'left',
    sortable: false
  }
]

export default {
  props: {
    documents: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    // Dynamically update headers based on the document fields
    dynamicHeaders() {
      const documentFields = this.documents.reduce((acc, doc) => {
        Object.keys(doc).forEach(key => {
          if (!acc.includes(key)) acc.push(key)
        })
        return acc
      }, [])

      const additionalHeaders = documentFields
        .filter(field => !originHeaders.some(header => header.value === field))
        .map(field => ({
          text: field.charAt(0).toUpperCase() + field.slice(1),
          value: field,
          align: 'left',
          sortable: false
        }))

      return [...originHeaders, ...additionalHeaders]
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {},
  watch: {
    documents: {
      handler() {
        this.headers = this.dynamicHeaders
      },
      immediate: true
    }
  }
}
</script>
